import { isWebAiWidgetAvailable } from '@/utils/webAiWidgetAvailability';

const DASHBOARD_ROUTE = { name: 'dashboard', replace: true };

const webAiWidgetRouteGuard = async (to, from, next) => {
  try {
    const isAvailable = await isWebAiWidgetAvailable();

    if (isAvailable) {
      next();
      return;
    }

    next(DASHBOARD_ROUTE);
  } catch {
    next(DASHBOARD_ROUTE);
  }
};

export default webAiWidgetRouteGuard;
